export const defaultTheme = {};
